/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxfAccountingV1AccountQueryServiceAccountGetAccountGetRequest, IxfAccountingV1AccountQueryServiceAccountGetResponse } from '@interxfi/types';

export const IXF_ACCOUNTING_V1_ACCOUNT_QUERY_SERVICE_ACCOUNT_GET_AUDIENCE = ['clearing'];

export async function ixfAccountingV1AccountQueryServiceAccountGet(baseUrl: string | undefined, request?: IxfAccountingV1AccountQueryServiceAccountGetAccountGetRequest, requestInit?: RequestInit): Promise<IxfAccountingV1AccountQueryServiceAccountGetResponse | undefined> { return makeRequest<IxfAccountingV1AccountQueryServiceAccountGetResponse, IxfAccountingV1AccountQueryServiceAccountGetAccountGetRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/ixf/accounting/v1/account/q/:accountId', request, requestInit)); }

